/* eslint-disable prettier/prettier */

// @mui material components
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import "rc-tree/assets/index.css";
import Tree, { TreeNode } from "rc-tree";
import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { InformacionInicialCatalogos } from "store/catalogos/catalogosActions";
import { find } from "lodash";

function formUsuario({ props, invalids, onChangeUser, onChangeInvalid, vista }) {
  const { rolesUsuarios } = useSelector((state) => state.roles);
  const { hospitales } = useSelector((state) => state.catalogos);

  const rolesUsuariosMostrar = useMemo(() => {
    return rolesUsuarios.filter((obj) => obj.activo != false);
  }, [rolesUsuarios]);

  const hospitalesMostrar = useMemo(() => {
    return hospitales.filter((obj) => obj.activo != false);
  }, [hospitales]);

  const {
    nombre,
    apellioPaterno,
    apellioMaterno,
    rolUsuario,
    hospital,
    correo,
    celular,
    username,
    password,
    confirmpassword,
  } = props;
  const {
    invalid_nombre,
    invalid_apellioPaterno,
    invalid_apellioMaterno,
    invalid_rolUsuario,
    invalid_hospital,
    invalid_correo,
    invalid_celular,
    invalid_username,
    invalid_password,
    invalid_confirmpassword,
  } = invalids;
  const [password1, setPassword1] = useState("");
  //show passwod
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  //show password confirm
  const [showPasswordconfirm, setShowPasswordconfirm] = useState(false);
  const handleClickShowPasswordconfirm = () => setShowPasswordconfirm((show) => !show);
  const handleMouseDownPasswordconfirm = (event) => {
    event.preventDefault();
  };
  const [validPassword, setValidPassword] = useState(false);
  const [esAdmin, setEsAdmin] = useState(rolUsuario?.rolUsuario == "Administración" ? true : false);

  const desactivarCampo = vista == "creacion" ? false : true;

  return (
    <>
      {(vista == "creacion" || vista == "perfil") && (
        <>
          <TextField
            value={nombre}
            onChange={(event) => {
              onChangeUser(event.target.value, "nombre");
            }}
            onFocus={() => {
              onChangeInvalid(false, "nombre");
            }}
            onBlur={() => {
              if (!nombre) onChangeInvalid(true, "nombre");
            }}
            disabled={desactivarCampo}
            error={invalid_nombre}
            helperText={invalid_nombre && "Campo obligatorio*"}
            label="Nombre"
            variant="outlined"
            style={{ width: "100%", marginBottom: "1.5rem" }}
            size="small"
          />
          <TextField
            value={apellioPaterno}
            onChange={(event) => {
              onChangeUser(event.target.value, "apellioPaterno");
            }}
            onFocus={() => {
              onChangeInvalid(false, "apellioPaterno");
              if (!nombre) {
                onChangeInvalid(true, "nombre");
              }
            }}
            onBlur={() => {
              if (!apellioPaterno) onChangeInvalid(true, "apellioPaterno");
            }}
            disabled={desactivarCampo}
            error={invalid_apellioPaterno}
            helperText={invalid_apellioPaterno && "Campo obligatorio*"}
            label="Apellido Paterno"
            variant="outlined"
            style={{ width: "100%", marginBottom: "1.5rem" }}
            size="small"
          />
          <TextField
            value={apellioMaterno}
            onChange={(event) => {
              onChangeUser(event.target.value, "apellioMaterno");
            }}
            onFocus={() => {
              if (!nombre) {
                onChangeInvalid(true, "nombre");
              }
              if (!apellioPaterno) {
                onChangeInvalid(true, "apellioPaterno");
              }
            }}
            disabled={desactivarCampo}
            error={false}
            helperText=""
            label="Apellido Materno"
            variant="outlined"
            style={{ width: "100%", marginBottom: "1.5rem" }}
            size="small"
          />
          <Autocomplete
            id="controlled-demo"
            options={rolesUsuariosMostrar}
            getOptionLabel={(option) => option.rolUsuario}
            value={
              find(rolesUsuarios, (opt) => opt.idRolUsuario == rolUsuario?.idRolUsuario) || null
            }
            onChange={(event, newValue) => {
              onChangeUser(newValue, "rolUsuario");
              if (newValue != null) {
                onChangeUser(newValue.permisos, "permisos");
                if (newValue.rolUsuario == "Administración") {
                  setEsAdmin(true);
                } else {
                  setEsAdmin(false);
                }
              }
            }}
            disabled={desactivarCampo}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Rol"
                variant="outlined"
                onFocus={() => {
                  onChangeInvalid(false, "rolUsuario");
                  if (!nombre) {
                    onChangeInvalid(true, "nombre");
                  }
                  if (!apellioPaterno) {
                    onChangeInvalid(true, "apellioPaterno");
                  }
                }}
                onBlur={() => {
                  if (rolUsuario == null) onChangeInvalid(true, "rolUsuario");
                }}
                error={invalid_rolUsuario}
                helperText={invalid_rolUsuario && "Campo obligatorio*"}
                disabled={desactivarCampo}
              />
            )}
            style={{ width: "100%", marginBottom: "1rem" }}
            size="small"
          />
          {!esAdmin && (
            <Autocomplete
              id="controlled-demo"
              options={hospitalesMostrar}
              getOptionLabel={(option) => option.hospital}
              value={
                find(hospitalesMostrar, (opt) => opt.idHospital === hospital?.idHospital) || null
              }
              onChange={(event, newValue) => {
                if (newValue != null) {
                  onChangeUser(newValue, "hospital");
                }
              }}
              disabled={desactivarCampo}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Hospital"
                  variant="outlined"
                  onFocus={() => {
                    onChangeInvalid(false, "hospital");
                    if (!nombre) {
                      onChangeInvalid(true, "nombre");
                    }
                    if (!apellioPaterno) {
                      onChangeInvalid(true, "apellioPaterno");
                    }
                    if (!rolUsuario) {
                      onChangeInvalid(true, "rolUsuario");
                    }
                  }}
                  // onBlur={() => {
                  //   if (hospital == null) onChangeInvalid(true, "hospital");
                  // }}
                  error={invalid_hospital}
                  helperText={invalid_hospital && "Campo obligatorio*"}
                  disabled={desactivarCampo}
                />
              )}
              style={{ width: "100%", marginBottom: "1rem" }}
              size="small"
            />
          )}
          <TextField
            value={correo}
            onChange={(event) => {
              onChangeUser(event.target.value, "correo");
            }}
            onFocus={() => {
              onChangeInvalid(false, "correo");
              if (!nombre) {
                onChangeInvalid(true, "nombre");
              }
              if (!apellioPaterno) {
                onChangeInvalid(true, "apellioPaterno");
              }
              if (!rolUsuario) {
                onChangeInvalid(true, "rolUsuario");
              }
              // if (!hospital) {
              //   onChangeInvalid(true, "hospital");
              // }
            }}
            onBlur={() => {
              if (!correo) onChangeInvalid(true, "correo");
            }}
            disabled={desactivarCampo}
            error={invalid_correo}
            helperText={invalid_correo && "Campo obligatorio*"}
            label="Correo"
            variant="outlined"
            style={{ width: "100%", marginBottom: "1.5rem" }}
            size="small"
          />
          <TextField
            value={celular}
            onChange={(event) => {
              const value = event.target.value;
              if (/^\d*$/.test(value)) {
                onChangeUser(value, "celular");
              }
            }}
            onFocus={() => {
              onChangeInvalid(false, "celular");
              if (!nombre) {
                onChangeInvalid(true, "nombre");
              }
              if (!apellioPaterno) {
                onChangeInvalid(true, "apellioPaterno");
              }
              if (!rolUsuario) {
                onChangeInvalid(true, "rolUsuario");
              }
              // if (!hospital) {
              //   onChangeInvalid(true, "hospital");
              // }
              if (!correo) {
                onChangeInvalid(true, "correo");
              }
            }}
            onBlur={() => {
              if (!celular) onChangeInvalid(true, "celular");
            }}
            inputProps={{
              inputMode: "numeric", // Muestra teclado numérico en móviles
              pattern: "[0-9]*", // Sugiere sólo números
              maxLength: 10, // Límite de 10 caracteres
            }}
            disabled={desactivarCampo}
            error={invalid_celular}
            helperText={invalid_celular && "Campo obligatorio*"}
            label="Celular"
            variant="outlined"
            style={{ width: "100%", marginBottom: "1.5rem" }}
            size="small"
          />
          <TextField
            value={username}
            onChange={(event) => {
              onChangeUser(event.target.value, "username");
            }}
            onFocus={() => {
              onChangeInvalid(false, "username");
              if (!nombre) {
                onChangeInvalid(true, "nombre");
              }
              if (!apellioPaterno) {
                onChangeInvalid(true, "apellioPaterno");
              }
              if (!rolUsuario) {
                onChangeInvalid(true, "rolUsuario");
              }
              // if (!hospital) {
              //   onChangeInvalid(true, "hospital");
              // }
              if (!correo) {
                onChangeInvalid(true, "correo");
              }
              if (!celular) {
                onChangeInvalid(true, "celular");
              }
            }}
            onBlur={() => {
              if (!username) onChangeInvalid(true, "username");
            }}
            disabled={desactivarCampo}
            error={invalid_username}
            helperText={invalid_username && "Campo obligatorio*"}
            label="UserName"
            variant="outlined"
            style={{ width: "100%", marginBottom: "1.5rem" }}
            size="small"
          />
        </>
      )}

      {vista == "creacion" && (
        <>
          <TextField
            value={password}
            type={showPassword ? "text" : "password"}
            onChange={(event) => {
              setPassword1(event.target.value);
              onChangeUser(event.target.value, "password");
            }}
            onFocus={() => {
              onChangeInvalid(false, "password");
              if (!nombre) {
                onChangeInvalid(true, "nombre");
              }
              if (!apellioPaterno) {
                onChangeInvalid(true, "apellioPaterno");
              }
              if (!rolUsuario) {
                onChangeInvalid(true, "rolUsuario");
              }
              // if (!hospital) {
              //   onChangeInvalid(true, "hospital");
              // }
              if (!correo) {
                onChangeInvalid(true, "correo");
              }
              if (!celular) {
                onChangeInvalid(true, "celular");
              }
              if (!username) {
                onChangeInvalid(true, "username");
              }
            }}
            onBlur={() => {
              if (!password) onChangeInvalid(true, "password");
            }}
            disabled={desactivarCampo}
            error={invalid_password}
            helperText={invalid_password && "Campo obligatorio*"}
            label="Password"
            variant="outlined"
            style={{ width: "100%", marginBottom: "1.5rem" }}
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? (
                      <Icon fontSize="small" color="secondary">
                        visibility_off
                      </Icon>
                    ) : (
                      <Icon fontSize="small" color="secondary">
                        visibility
                      </Icon>
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            value={confirmpassword}
            type={showPasswordconfirm ? "text" : "password"}
            onChange={(event) => {
              if (event.target.value != password1) {
                setValidPassword(true);
              } else {
                setValidPassword(false);
              }
              onChangeUser(event.target.value, "confirmpassword");
            }}
            onFocus={() => {
              onChangeInvalid(false, "confirmpassword");
              if (!nombre) {
                onChangeInvalid(true, "nombre");
              }
              if (!apellioPaterno) {
                onChangeInvalid(true, "apellioPaterno");
              }
              if (!rolUsuario) {
                onChangeInvalid(true, "rolUsuario");
              }
              // if (!hospital) {
              //   onChangeInvalid(true, "hospital");
              // }
              if (!correo) {
                onChangeInvalid(true, "correo");
              }
              if (!celular) {
                onChangeInvalid(true, "celular");
              }
              if (!username) {
                onChangeInvalid(true, "username");
              }
              if (!password) {
                onChangeInvalid(true, "password");
              }
            }}
            onBlur={() => {
              if (!confirmpassword) onChangeInvalid(true, "confirmpassword");
            }}
            disabled={desactivarCampo}
            error={validPassword || invalid_confirmpassword}
            helperText={
              (validPassword && "Las contraseñas no coinciden") ||
              (invalid_confirmpassword && "Campo obligatorio*")
            }
            label="Confirmar Password"
            variant="outlined"
            style={{ width: "100%", marginBottom: "1.5rem" }}
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPasswordconfirm}
                    onMouseDown={handleMouseDownPasswordconfirm}
                    edge="end"
                  >
                    {showPasswordconfirm ? (
                      <Icon fontSize="small" color="secondary">
                        visibility_off
                      </Icon>
                    ) : (
                      <Icon fontSize="small" color="secondary">
                        visibility
                      </Icon>
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </>
      )}
    </>
  );
}

formUsuario.defaultProps = {
  props: {},
};

formUsuario.propTypes = {
  props: PropTypes.object.isRequired,
  onChangeUser: PropTypes.func.isRequired,
};

export default formUsuario;
